export const SERVICES = [
    {
        id: "classique",
        name: "Massage Classique",
        subtitle: "Détente ou Thérapeutique",
        description:
            "Une approche complète pour relâcher les tensions musculaires et profondes. Idéal pour la récupération et le bien-être général.",
        variants: [
            { id: "classique-60", label: "60 min", price: 80 },
            { id: "classique-90", label: "90 min", price: 120 },
            { id: "classique-120", label: "2 h", price: 160 },
        ],
        tag: "Populaire",
        accent: "terracotta",
    },
    {
        id: "releve",
        name: "Massage Relève",
        subtitle: "Étudiant·e et 60 ans et +",
        description:
            "Une offre accessible et bienveillante pour les étudiant·e·s (carte étudiante requise) et les personnes de 60 ans et plus.",
        variants: [
            { id: "releve-60", label: "60 min", price: 70 },
            { id: "releve-90", label: "90 min", price: 110 },
            { id: "releve-120", label: "2 h", price: 150 },
        ],
        tag: "Accessible",
        accent: "turquoise",
    },
    {
        id: "biocorporel",
        name: "Massage Biocorporel",
        subtitle: "Reconnexion corps & esprit",
        description:
            "Un travail intégratif qui mobilise la respiration, le toucher conscient et l'écoute somatique pour un alignement profond.",
        variants: [
            { id: "biocorporel-60", label: "60 min", price: 100 },
            { id: "biocorporel-90", label: "90 min", price: 140 },
            { id: "biocorporel-120", label: "2 h", price: 180 },
        ],
        accent: "turquoise",
    },
    {
        id: "signature",
        name: "Massage Signature",
        subtitle: "Création de Jérémy",
        description:
            "Une expérience signature mêlant techniques manuelles précises, écoute profonde et touches musicothérapeutiques pour un soin véritablement unique.",
        variants: [
            { id: "signature-90", label: "90 min", price: 140 },
            { id: "signature-120", label: "2 h", price: 180 },
        ],
        tag: "Signature",
        accent: "turquoise",
    },
    {
        id: "enrichi",
        name: "Massage Enrichi",
        subtitle: "Soin complet 2h",
        description:
            "L'expérience la plus complète : un voyage profond combinant massage thérapeutique, paysages sonores vibratoires et respiration guidée.",
        variants: [{ id: "enrichi-120", label: "2 h", price: 180 }],
        tag: "Premium",
        accent: "turquoise",
    },
    {
        id: "psychocorporel",
        name: "Massage Californien",
        subtitle: "Aromathérapie · Méditation guidée · Enveloppant",
        description:
            "À mi-chemin entre le Classique et le Signature. Mouvements enveloppants type californien, huiles essentielles diffusées (aromathérapie) et méditation guidée intégrée. Idéal contre l'anxiété diffuse et pour se reconnecter en profondeur.",
        variants: [
            { id: "psychocorporel-60", label: "60 min", price: 90 },
            { id: "psychocorporel-90", label: "90 min", price: 130 },
        ],
        tag: "Aromathérapie",
        accent: "turquoise",
        details: {
            deroulement:
                "Accueil, court échange sur votre état émotionnel du jour et diffusion d'huiles essentielles (lavande, petit grain, ylang-ylang) dès votre entrée. Puis, sur la table, je travaille par longs mouvements californiens enveloppants — épaules, dos, bassin, jambes, bras — en synchronisant chaque geste avec votre respiration. À trois moments clés, je propose une brève méditation guidée (30 s à 2 min) : ancrage, scan corporel, visualisation. À domicile, la séance peut être ponctuée d'une expérience Aufguss (voir section Confort & outils).",
            bienfaits: [
                "Baisse rapide de l'anxiété diffuse et du stress mental",
                "Retour au corps chez les personnes très cérébrales",
                "Amélioration du sommeil dès la nuit suivante",
                "Sentiment durable d'unité corps-esprit après la séance",
                "Détente profonde du système nerveux autonome",
            ],
        },
    },
    {
        id: "cible",
        name: "Massage Thérapeutique Ciblé",
        subtitle: "Partiel · zone localisée · 30 min",
        description:
            "Séance courte de 30 minutes dédiée à une seule zone (dos, cou, épaules, genou, coude, sciatique, bras, poignet). Parfait pour ceux qui n'aiment pas les massages intégraux ou qui veulent traiter précisément une tension.",
        variants: [
            { id: "cible-30", label: "30 min", price: 55 },
        ],
        tag: "Rapide",
        accent: "terracotta",
        details: {
            deroulement:
                "5 minutes d'échange précis pour cibler la zone et l'histoire de la douleur, puis 25 minutes de travail manuel dédié : pressions profondes, points gâchette (trigger points), étirements myofasciaux, mobilisations articulaires douces et, si besoin, drainage lymphatique local. Vous restez en sous-vêtement ou habillé selon la zone travaillée. Format sec, direct, sans travail intégral.",
            bienfaits: [
                "Soulagement rapide d'une tension localisée (dos, cou, épaule, sciatique…)",
                "Format idéal en pause déjeuner ou entre deux rendez-vous",
                "Alternative aux personnes qui n'aiment pas les massages intégraux",
                "Excellent pour tester la massothérapie sans engagement long",
                "Peut s'enchaîner sur 2-3 séances rapprochées pour un effet cumulatif",
            ],
        },
    },
    {
        id: "vetement-habille",
        name: "Massage sur Vêtement Habillé",
        subtitle: "Sans huile · sans drap · tous clients",
        description:
            "Massage pratiqué habillé (vêtements souples), sans huile ni drapage. Techniques adaptées : compressions, étirements, mobilisations. Offert au même prix pour toute la clientèle — étudiants, réguliers, nouveaux — sans distinction.",
        variants: [
            { id: "vetement-60", label: "60 min", price: 70 },
        ],
        tag: "Accessible",
        accent: "turquoise",
        details: {
            deroulement:
                "Vous arrivez en vêtements souples (jogging, leggings, t-shirt). Aucun changement, aucun drapage, aucune huile. Je travaille directement à travers le tissu avec des techniques adaptées : compressions rythmées, mobilisations articulaires, étirements assistés, pressions ciblées. Le soin couvre le corps entier — jambes, dos, bras, cou, épaules — sur la table de massage habituelle, en 60 minutes.",
            bienfaits: [
                "Idéal pour un tout premier massage — aucun frein d'exposition",
                "Compatible personnes réservées, débutants, mobilité réduite",
                "Réduction du stress et libération des tensions du haut du corps",
                "Format professionnel : reprendre le travail juste après la séance",
                "Tarif unique 70 $ pour toute la clientèle sans distinction",
            ],
        },
    },
    {
        id: "oriental-fusion",
        name: "Massage Oriental Fusion",
        subtitle: "Abhyanga + Balinais · Occident-Orient",
        description:
            "Fusion de deux grandes traditions orientales : l'Abhyanga ayurvédique (Inde, huiles chaudes, longs mouvements enveloppants sur les chakras et méridiens) et le massage Balinais (Indonésie, pressions rythmées, étirements doux, techniques d'acupression). Une approche complète Occident-Orient pour une détente profonde du corps et de l'esprit.",
        variants: [
            { id: "oriental-60", label: "60 min", price: 90 },
        ],
        tag: "Oriental",
        accent: "magenta",
        details: {
            deroulement:
                "Accueil, court échange sur votre état du jour et choix des huiles chaudes (sésame, coco, jasmin selon dosha ayurvédique). Puis, sur la table : longs mouvements enveloppants type Abhyanga sur tout le corps pour activer la circulation lymphatique, ponctués de pressions rythmées et d'étirements doux type Balinais sur les zones tendues. Points marma (Inde) et acupression (Bali) travaillés en fin de séance. À domicile : 110 $ (déplacement inclus dans le tarif).",
            bienfaits: [
                "Détente profonde du système nerveux (parasympathique)",
                "Activation de la circulation lymphatique et sanguine (huiles chaudes)",
                "Libération des tensions musculaires + travail énergétique (points marma & acupression)",
                "Retour à l'équilibre corps-esprit selon la tradition ayurvédique",
                "Approche unique — fusion des deux plus grandes traditions asiatiques du toucher",
            ],
        },
    },
];

export const PACKAGES = [
    { id: "forfait-3", count: 3, price: 200, save: 40 },
    { id: "forfait-6", count: 6, price: 400, save: 80 },
    { id: "forfait-9", count: 9, price: 600, save: 120 },
    { id: "forfait-12", count: 12, price: 800, save: 160 },
];

// flat list of bookable variants
export const BOOKABLE_SERVICES = SERVICES.flatMap((s) =>
    s.variants.map((v) => ({
        id: v.id,
        label: `${s.name} — ${v.label} (${v.price}$)`,
        price: v.price,
    }))
);

export const TIME_SLOTS = [
    "09:00", "10:00", "11:00",
    "13:00", "14:00", "15:00", "16:00", "17:00", "18:00",
];

export const THERAPIST = {
    name: "Jérémy Tessier",
    phone: "438-985-6709",
    email: "Jaytes2003@gmail.com",
    address: "1436 boulevard Curé-Labelle, Blainville",
};
